var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Interface } from '@ethersproject/abi';
import { Contract } from '@ethersproject/contracts';
import { jsonToGraphQLQuery } from 'json-to-graphql-query';
import Ajv from 'ajv';
import addFormats from 'ajv-formats';
import { abi as multicallAbi } from './abi/Multicall.json';
import _strategies from './strategies';
import Multicaller from './utils/multicaller';
import getProvider from './utils/provider';
import { decodeContenthash, validateContent, isValidContenthash, encodeContenthash, resolveENSContentHash, resolveContent } from './utils/contentHash';
import { signMessage, getBlockNumber } from './utils/web3';
import gateways from './gateways.json';
import networks from './networks.json';
export var MULTICALL = {
    '1': '0xeefba1e63905ef1d7acba5a8513c70307c1ce441',
    '3': '0x53c43764255c17bd724f74c4ef150724ac50a3ed',
    '4': '0x42ad527de7d4e9d9d011ac45b31d8551f8fe9821',
    '5': '0x77dca2c955b15e9de4dbbcf1246b4b85b651e50e',
    '6': '0x53c43764255c17bd724f74c4ef150724ac50a3ed',
    '17': '0xB9cb900E526e7Ad32A2f26f1fF6Dee63350fcDc5',
    '30': '0x4eeebb5580769ba6d26bfd07be636300076d1831',
    '31': '0x4eeebb5580769ba6d26bfd07be636300076d1831',
    '42': '0x2cc8688c5f75e365aaeeb4ea8d6a480405a48d2a',
    '56': '0x41263cBA59EB80dC200F3E2544eda4ed6A90E76C',
    '70': '0xd4b794b89baccb70ef851830099bee4d69f19ebc',
    '65': '0x23Daae12B7f82b1f0A276cD4f49825DE940B6374',
    '66': '0x5031F781E294bD918CfCf5aB7fe57196DeAA7Efb',
    '82': '0x579De77CAEd0614e3b158cb738fcD5131B9719Ae',
    '97': '0x8b54247c6BAe96A6ccAFa468ebae96c4D7445e46',
    '100': '0xb5b692a88bdfc81ca69dcb1d924f59f0413a602a',
    '128': '0x37ab26db3df780e7026f3e767f65efb739f48d8e',
    '137': '0xCBca837161be50EfA5925bB9Cc77406468e76751',
    '246': '0x0767F26d0D568aB61A98b279C0b28a4164A6f05e',
    '256': '0xC33994Eb943c61a8a59a918E2de65e03e4e385E0',
    '1287': '0xD7bA481DE7fB53A7a29641c43232B09e5D9CAe7b',
    '1337': '0x566131e85d46cc7BBd0ce5C6587E9912Dc27cDAc',
    '2109': '0x7E9985aE4C8248fdB07607648406a48C76e9e7eD',
    wanchain: '0xba5934ab3056fca1fa458d30fbb3810c3eb5145f',
    '250': '0x7f6A10218264a22B4309F3896745687E712962a0',
    '499': '0x7955FF653FfDBf13056FeAe227f655CfF5C194D5',
    '42220': '0xb8d0d2C1391eeB350d2Cd39EfABBaaEC297368D9',
    '4689': '0x9c8B105c94282CDB0F3ecF27e3cfA96A35c07be6',
    '4690': '0x30aE8783d26aBE7Fbb9d83549CCb7430AE4A301F',
    '1666600000': '0x9c31392D2e0229dC4Aa250F043d46B9E82074BF8',
    '1666700000': '0x9923589503Fd205feE3d367DDFF2378f0F7dD2d4'
};
export var SNAPSHOT_SUBGRAPH_URL = {
    '1': 'https://api.thegraph.com/subgraphs/name/snapshot-labs/snapshot',
    '4': 'https://api.thegraph.com/subgraphs/name/snapshot-labs/snapshot-rinkeby',
    '42': 'https://api.thegraph.com/subgraphs/name/snapshot-labs/snapshot-kovan'
};
export var SNAPSHOT_SCORE_API = 'https://score.snapshot.org/api/scores';
export function call(provider, abi, call, options) {
    return __awaiter(this, void 0, void 0, function () {
        var contract, params, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    contract = new Contract(call[0], abi, provider);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    params = call[2] || [];
                    return [4 /*yield*/, contract[call[1]].apply(contract, __spreadArrays(params, [options || {}]))];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    e_1 = _a.sent();
                    return [2 /*return*/, Promise.reject(e_1)];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function multicall(network, provider, abi, calls, options) {
    return __awaiter(this, void 0, void 0, function () {
        var multi, itf, _a, res, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    multi = new Contract(MULTICALL[network], multicallAbi, provider);
                    itf = new Interface(abi);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, multi.aggregate(calls.map(function (call) { return [
                            call[0].toLowerCase(),
                            itf.encodeFunctionData(call[1], call[2])
                        ]; }), options || { gas: 8000000, gasLimit: 8000000 })];
                case 2:
                    _a = _b.sent(), res = _a[1];
                    return [2 /*return*/, res.map(function (call, i) { return itf.decodeFunctionResult(calls[i][1], call); })];
                case 3:
                    e_2 = _b.sent();
                    return [2 /*return*/, Promise.reject(e_2)];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function subgraphRequest(url, query, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var res, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        headers: __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, options === null || options === void 0 ? void 0 : options.headers),
                        body: JSON.stringify({ query: jsonToGraphQLQuery({ query: query }) })
                    })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data || {}];
            }
        });
    });
}
export function getUrl(uri) {
    var uriScheme = uri.split('://')[0];
    var ipfsGateway = "https://" + gateways[0];
    if (uriScheme === 'ipfs')
        return uri.replace('ipfs://', ipfsGateway + "/ipfs/");
    if (uriScheme === 'ipns')
        return uri.replace('ipns://', ipfsGateway + "/ipns/");
    return uri;
}
export function ipfsGet(gateway, ipfsHash, protocolType) {
    if (protocolType === void 0) { protocolType = 'ipfs'; }
    return __awaiter(this, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            url = "https://" + gateway + "/" + protocolType + "/" + ipfsHash;
            return [2 /*return*/, fetch(url).then(function (res) { return res.json(); })];
        });
    });
}
export function sendTransaction(web3, contractAddress, abi, action, params, overrides) {
    if (overrides === void 0) { overrides = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var signer, contract, contractWithSigner;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    signer = web3.getSigner();
                    contract = new Contract(contractAddress, abi, web3);
                    contractWithSigner = contract.connect(signer);
                    return [4 /*yield*/, contractWithSigner[action].apply(contractWithSigner, __spreadArrays(params, [overrides]))];
                case 1: 
                // overrides.gasLimit = 12e6;
                return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function _getScoresBatchWrap(space, strategies, network, provider, addresses, snapshot, isdirect) {
    if (snapshot === void 0) { snapshot = 'latest'; }
    if (isdirect === void 0) { isdirect = false; }
    return __awaiter(this, void 0, void 0, function () {
        var batch, result, fire, ii, res, _a, res, final_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(networks[network] && networks[network].batchMax > 0)) return [3 /*break*/, 11];
                    if (!(addresses.length > networks[network].batchMax)) return [3 /*break*/, 11];
                    batch = networks[network].batchMax;
                    result = [];
                    fire = [];
                    ii = 0;
                    _b.label = 1;
                case 1:
                    if (!(ii < addresses.length)) return [3 /*break*/, 8];
                    if (!(ii % batch == 0)) return [3 /*break*/, 6];
                    if (!(fire.length > 0)) return [3 /*break*/, 6];
                    if (!isdirect) return [3 /*break*/, 3];
                    return [4 /*yield*/, getScoresDirect(space, strategies, network, provider, fire, snapshot)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, getScores(space, strategies, network, provider, fire, snapshot)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    res = _a;
                    result.push(res);
                    fire = [];
                    _b.label = 6;
                case 6:
                    fire.push(addresses[ii]);
                    _b.label = 7;
                case 7:
                    ii++;
                    return [3 /*break*/, 1];
                case 8:
                    if (!(fire.length > 0)) return [3 /*break*/, 10];
                    return [4 /*yield*/, getScores(space, strategies, network, provider, fire, snapshot)];
                case 9:
                    res = _b.sent();
                    result.push(res);
                    fire = [];
                    _b.label = 10;
                case 10:
                    final_1 = {};
                    result.forEach(function (map, i) {
                        // console.log("map",map);
                        map.forEach(function (el) {
                            // console.log("el",el);
                            final_1 = Object.assign(final_1, el);
                        });
                    });
                    return [2 /*return*/, [final_1]];
                case 11: return [2 /*return*/, getScores(space, strategies, network, provider, addresses, snapshot)];
            }
        });
    });
}
export function getScoresBatchWrap(space, strategies, network, provider, addresses, snapshot) {
    if (snapshot === void 0) { snapshot = 'latest'; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, _getScoresBatchWrap(space, strategies, network, provider, addresses, snapshot, false)];
        });
    });
}
export function getScoresDirectBatchWrap(space, strategies, network, provider, addresses, snapshot) {
    if (snapshot === void 0) { snapshot = 'latest'; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, _getScoresBatchWrap(space, strategies, network, provider, addresses, snapshot, true)];
        });
    });
}
export function getScores(space, strategies, network, provider, addresses, snapshot) {
    if (snapshot === void 0) { snapshot = 'latest'; }
    return __awaiter(this, void 0, void 0, function () {
        var params, res, obj, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    params = {
                        space: space,
                        network: network,
                        snapshot: snapshot,
                        strategies: strategies,
                        addresses: addresses
                    };
                    return [4 /*yield*/, fetch(SNAPSHOT_SCORE_API, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ params: params })
                        })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    obj = _a.sent();
                    return [2 /*return*/, obj.result.scores];
                case 3:
                    e_3 = _a.sent();
                    return [2 /*return*/, Promise.reject(e_3)];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function getScoresDirect(space, strategies, network, provider, addresses, snapshot) {
    if (snapshot === void 0) { snapshot = 'latest'; }
    return __awaiter(this, void 0, void 0, function () {
        var e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log('getScoresDirect');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all(strategies.map(function (strategy) {
                            var _a, _b, _c;
                            return (snapshot !== 'latest' && ((_a = strategy.params) === null || _a === void 0 ? void 0 : _a.start) > snapshot) ||
                                (((_b = strategy.params) === null || _b === void 0 ? void 0 : _b.end) &&
                                    (snapshot === 'latest' || snapshot > ((_c = strategy.params) === null || _c === void 0 ? void 0 : _c.end))) ||
                                addresses.length === 0
                                ? {}
                                : _strategies[strategy.name](space, network, provider, addresses, strategy.params, snapshot);
                        }))];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    e_4 = _a.sent();
                    return [2 /*return*/, Promise.reject(e_4)];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function validateSchema(schema, data) {
    var ajv = new Ajv({ allErrors: true, allowUnionTypes: true, $data: true });
    // @ts-ignore
    addFormats(ajv);
    var validate = ajv.compile(schema);
    var valid = validate(data);
    return valid ? valid : validate.errors;
}
export default {
    call: call,
    multicall: multicall,
    subgraphRequest: subgraphRequest,
    ipfsGet: ipfsGet,
    sendTransaction: sendTransaction,
    getScores: getScores,
    getScoresDirect: getScoresDirect,
    getScoresBatchWrap: getScoresBatchWrap,
    getScoresDirectBatchWrap: getScoresDirectBatchWrap,
    validateSchema: validateSchema,
    getProvider: getProvider,
    decodeContenthash: decodeContenthash,
    validateContent: validateContent,
    isValidContenthash: isValidContenthash,
    encodeContenthash: encodeContenthash,
    resolveENSContentHash: resolveENSContentHash,
    resolveContent: resolveContent,
    signMessage: signMessage,
    getBlockNumber: getBlockNumber,
    Multicaller: Multicaller
};
